module.exports = __webpack_public_path__ + "static/media/dragIcon.132757e5.svg";